export interface IGetWalletPaymentResponse {
  id: number,
  customerId: number,
  amount: number,
  status: string,
  type: string,
  transactionType: string,
  transactionDirection: string,
  referenceId: string,
  subType: string,
  title: string,
  description: string,
  created: number
}


export const GetTransFormedWalletPaymentResponse = (data: IGetWalletPaymentResponse): IGetWalletPaymentResponse => {
    return {
      id: data.id,
      customerId: data.customerId,
      amount: data.amount,
      status: data.status,
      type: data.type,
      transactionType: data.transactionType,
      transactionDirection: data.transactionDirection,
      referenceId: data.referenceId,
      subType: data.subType,
      title: data.title,
      description: data.description,
      created: data.created
    };
  };
